(() => {
  'use strict';
  
  const SECTION = document.querySelector('.nextdev--multicolumn-products');
  const SWIPER = SECTION.querySelector('.swiper');

  const swiperInstance = new Swiper(SWIPER, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    slidesPerGroup: 1,
      
    mousewheel: {
      forceToAxis: true
    },

    pagination: {
      el: '.swiper--multicolumn-products-pagination'
    },

    navigation: {
      prevEl: '.swiper--multicolumn-products-button-prev',
      nextEl: '.swiper--multicolumn-products-button-next'
    },

    breakpoints: {
      750: {
        slidesPerGroup: 3
      }
    }
  });
})();
